<template>
    <div class="list" :customInfoId="listmsg.customInfoId">
        <a   :href="listmsg.infoContentFullUrl"> 
            <div class="list_img">
                <img :src="listmsg.coverImage||require('../../static/images/share_1.png')" class="">
            </div>
            <p>{{listmsg.infoTitle||'比笔'}}</p>
        </a>
        <div class="list_names clearfloat">
            <!-- <img :src="listmsg.memberSmallImg" class="list_head"> -->
            <span class="names">{{listmsg.inputDate||'比笔'}}</span><!-- 日期 -->
            <div class="watch_num">
                <div class="clearfloat">
<!--                    <div class="down">-->
<!--                        <img src="../../static/images/icon-unlike-btn.png" class="down_img">-->
<!--                    </div>-->
                    <div style="float:right;min-width:.84rem">
                        <!-- 为0时 显示投票 -->
                        <!-- <span class=" center">{{listmsg.voteNum?'0':'投票'}}</span> -->
                        <span class=" center" v-if="center">{{listmsg.voteNumShow||'0'}}</span>
                        <span class=" center" v-if="vote" @click="voteclick" style="font-size:.24rem">{{listmsg.voteNumShow||'0'}}</span>
                    </div>
                    <div class="up">
                        <img src="../../static/images/star.png" class="up_img">
                    </div>
                    <span class="num">{{listmsg.hits||'0'}}</span>
                    <div class="watch">
                        <img src="../../static/images/icon-read-btn.png" class="watch_img">
                    </div>
                </div>    
            </div>
        </div>
    </div>
</template>
<script>
import webCoobyApp from "../js/coobyApp";
export default {
    name: 'list',
     props:{
      listmsg: {
        type: Object,
        default:''
      }
    },
    data() {
        return {
            center:true,
            vote:false
        }
    },
    methods: {
        voteclick(){
            webCoobyApp.coobyUtils.downApp();
        }
    },
    mounted() {
        if(this.listmsg.voteNumShow=='投票'){
            this.center=false;
            this.vote=true;
        }else{
            this.vote=true;
            this.center=false
        }
        // console.log(this.listmsg.voteNumShow=='投票')


        
    }
}
</script>

<style scoped>
img {
    display: block;
}
.list {
    width: 100%;
    height: 4.6rem;
    margin-bottom: .16rem;
    background: #fff;
}
.list_img {
    overflow: hidden;
    width: 100%;
    height: 3.26rem;
}
.list_img img {
    width: 100%;
    height: 100%;
}
.list p {
    width: 100%;
    height: .68rem;
    padding: 0 .3rem;
    font-size: .32rem;
    line-height: .68rem;
    color: #17191a;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
}
.list_names {
    width: 100%;
    height: .44rem;
    padding: 0 .3rem;
    position: relative;
}
.list_names .list_head {
    display: block;
    float: left;
    width: .44rem;
    height: 100%;
        border-radius: 50%;
}
.list_names .names {
    display: block;
    float: left;
    height: 100%;
    font-size: .26rem;
    line-height: .44rem;
    color: #778c99;
}
.watch_num {
    float: right;
    margin-top: -.11rem;
    position: absolute;
    top: 50%;
    right: .3rem;
}
.watch_num .watch {
    float: right;
    margin-top: 3px;
    vertical-align: text-top;
}
.watch_img {
    width: .34rem;
    height: .22rem;
    vertical-align: text-top;
}
.watch_num .num {
    display: block;
    float: right;
    margin-left: .1rem;
    font-size: .28rem;
    line-height: .34rem;
    color: #778c99;
    min-width: .9rem;
}
.watch_num  .center{
    margin-left: 0;
    text-align: center;
    display: block;
    font-size: .28rem;
    line-height: .34rem;
    color: #778c99;
    padding: 0  .12rem;

}
.watch_num .up {
    float: right;
}
.up_img {
    width: .36rem;
    height: .35rem;
    vertical-align: text-top;
}
.watch_num .down {
    float: right;
    vertical-align: middle;
}
.down_img {
    width: .22rem;
    height: .25rem;
    vertical-align: text-top;
}
</style>



// WEBPACK FOOTER //
// List.vue?0adb2c94